"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const async_1 = tslib_1.__importDefault(require("react-select/async"));
const reactstrap_1 = require("reactstrap");
const graphql_1 = require("../../../../../graphql");
// const DropdownIndicator = (props: any) => {
//   return (
//     <components.DropdownIndicator {...props}>
//       {/* <EmojiIcon primaryColor={colourOptions[2].color} /> */}F
//     </components.DropdownIndicator>
//   );
// };
const RESOURCES = {
    user: {
        labels: {
            entity: 'User',
            name: 'User',
        },
        paths: {
            count: 'usersCount',
            id: '',
            label: 'fullName',
            objects: 'users',
        },
        query: {
            query: graphql_1.users,
        },
        selectProps: {},
    },
    workspace: {
        labels: {
            entity: 'Workspace',
            name: 'Workspace',
        },
        paths: {
            count: 'workspacesCount',
            id: 'name',
            label: 'name',
            objects: 'workspaces',
        },
        query: {
            query: graphql_1.workspaces,
        },
    },
};
function ResourceSelectorInner({ data, resourceData, onChange, error, value, loading, isMulti, label, }) {
    const { paths, labels } = resourceData;
    const optionsData = react_1.useMemo(() => {
        return lodash_1.get(data, paths.objects);
    }, [data, paths.objects]);
    const select = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(async_1.default, { className: "mb-2", value: value, isLoading: loading, isClearable: true, isMulti: isMulti, placeholder: `Select ${labels.name}`, onChange: opts => {
                onChange(opts);
            }, getOptionLabel: opt => {
                return lodash_1.get(opt, paths.label);
            }, getOptionValue: opt => {
                return lodash_1.get(opt, paths.id);
            }, styles: {
                control: styles => (Object.assign(Object.assign({}, styles), { borderColor: error ? 'red' : styles.borderColor })),
            }, defaultOptions: optionsData, cacheOptions: true, loadOptions: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                return optionsData;
            }) })));
    if (label !== false) {
        return (react_1.default.createElement(reactstrap_1.FormGroup, null,
            react_1.default.createElement(reactstrap_1.Label, null, labels.name),
            select));
    }
    return select;
}
exports.ResourceSelectorInner = ResourceSelectorInner;
function ResourceSelector(props) {
    const resourceData = RESOURCES[props.resource];
    // const { setState, state } = useSetState<{
    //   value: any;
    // }>({
    //   value: props.value,
    // });
    // useDebounce(
    //   () => {
    //     props.onChange(state.value);
    //   },
    //   10,
    //   [state.value]
    // );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _a = resourceData.query, { query } = _a, queryProps = tslib_1.__rest(_a, ["query"]);
    const result = react_hooks_1.useQuery(resourceData.query.query, queryProps);
    return (react_1.default.createElement(ResourceSelectorInner, Object.assign({}, props, result, { value: props.value, resourceData: resourceData, onChange: v => {
            props.onChange(v);
        } })));
}
exports.ResourceSelector = ResourceSelector;
//# sourceMappingURL=index.js.map